// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__1fbRa","icon":"SortAdornment_icon__3eoCI","up":"SortAdornment_up__lxGa9","down":"SortAdornment_down__3_f3e","active":"SortAdornment_active__1ZY3D"};